export default "__VITE_ASSET__fRyKAR2E__"